import { render, staticRenderFns } from "./detile.vue?vue&type=template&id=2dedd2bd&scoped=true"
import script from "./detile.vue?vue&type=script&lang=js"
export * from "./detile.vue?vue&type=script&lang=js"
import style0 from "./detile.vue?vue&type=style&index=0&id=2dedd2bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dedd2bd",
  null
  
)

export default component.exports